<template src="./html/Jobs.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'schedule'],
		components: {
			
		},
		data () {
			return {
				modal: {
					selector: 'jobs',
				},
				units: [
					{
						value: 'minutes',
						name: 'Minutos'
					},
					{
						value: 'hours',
						name: 'Horas'
					},
					{
						value: 'days',
						name: 'Días'
					},
					{
						value: 'weeks',
						name: 'Semanas'
					},
				],
				newData: [],
				data: [],
			}
		},
		mounted(){
			this.modal.selector = 'jobs-'+this.schedule.id
			var that = this
			var modal = $('#'+this.modal.selector)
			modal.on('hidden.bs.modal', function() {
				that.clearData()
			})
		},
		methods: {
			init() {
				this.getData()
			},
			open(data) {
				this.clearData()
				this.getData()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				this.clearData()
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.data = []
				this.newData = []
			},
			deleteData(data) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/jobs/'+data.id)
							.then(response => {
								let index = that.data.indexOf(data)
								that.data.splice(index, 1)
								swal({
									'title': response.body.title,
									'text': response.body.text,
									'type': response.body.type})
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			getData() {
				if(this.schedule) {
					var api = 'admin/projects/schedules/' + this.schedule.id + '/jobs'
					this.$http.get(api)
					.then(response => {
						this.data = response.body
						var that = this
						this.data.forEach(function(element) {
							element.schedule_id = that.schedule.id
						})
					}).catch(function(response) {
						console.log(response)
					})
				}
			},
			save() {
				this.update()
			},
			update() {
				var loading = Ladda.create(document.querySelector('#btn-store'))
				loading.start()
				var data = {
					jobs: this.data
				}
				this.$http.post('admin/jobs/updates', data)
				.then(response => {
					loading.stop()
					if(this.newData.length) {
						this.store()
					} else {
						this.data = null
						this.getData()
					}
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
			store() {
				var loading = Ladda.create(document.querySelector('#btn-store'))
				loading.start()
				var data = {
					jobs: this.newData
				}
				this.$http.post('admin/jobs', data)
				.then(response => {
					this.newData = []
					loading.stop()
					this.data = null
					this.getData()
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
			quitData(data) {
				let index = this.newData.indexOf(data)
				this.newData.splice(index, 1)
			},
			addData() {
				var data = {
					schedule_id: this.schedule.id,
					user_id: null,
					value: 0,
					unit: 'minutes',
				}
				this.newData.push(data)
			},
			parseTimeStamp(available_at, reminder) {
				var available = moment.unix(available_at).format("YYYY-MM-DD HH:mm:ss");
				var date = moment(this.schedule.start_date + ' ' + this.schedule.start_time).format("YYYY-MM-DD HH:mm:ss");

				var start_schedule = moment(date)
				var start_job = moment(available)

				var duration = moment.duration(start_schedule.diff(start_job))

				if(reminder == 'minutes') {
					var time = duration.asMinutes()
				} else if(reminder == 'hours') {
					var time = duration.asHours()
				} else if(reminder == 'days') {
					var time = duration.asDays()
				} else if(reminder = 'weeks') {
					var time = duration.asWeeks()
				}
				return parseInt(time);
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/jobs/Jobs.vue